<script>
  export let message;
  export let customStyle;
  export let type = 'error';
  let className = 'alert-danger-block';
  let imageName = 'warning.svg';

  if (type === 'success') {
    className = 'alert-success-block';
    imageName = 'tick.svg';
  } else if (type === 'warning') {
    className = 'alert-success-block';
  } else {
    className = 'alert-danger-block';
  }
</script>

{#if message.length != 0}
  <div
    class="alert w-100 py-2 {customStyle} {className}"
    role="alert"
  >
    <div class="d-flex flex-row w-100 align-items-center">
      <div class="me-2">
        <img
          style="width:25px; margin-right:9px"
          alt=""
          src="/images/{imageName}"
        />
      </div>
      <div>
        {#each message as item}
          {item}
        {/each}
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .alert-danger-block {
    background-color: #ed615c;
    color: $white-color;
  }
  .alert-success-block {
    background-color: rgb(49, 164, 49);
    color: $white-color;
  }
</style>
